// 사진 그리기 데이터 형식 (defect_photos.drawing, facility_photos.drawing)
// 원본 사진은 건드리지 않고 벡터 JSON으로 저장한다. 좌표는 화면에 보이는 방향 기준 정규화(0..1).
// 계획: plan/photo-brush/00-overview.md §4.1

export const PHOTO_DRAWING_VERSION = 1

export type PhotoStrokeKind = 'free' | 'poly'

export interface PhotoStroke {
  // free: 자유곡선(tension 0.5, round). poly: 영역 사각형과 그 조각(tension 0, miter)
  kind: PhotoStrokeKind
  // [x0, y0, x1, y1, ...] 이미지 원본 크기 대비 0..1, 소수 4자리 반올림
  points: number[]
  // 팔레트 rgba 값 그대로
  color: string
  // 이미지 짧은 변 대비 비율
  width: number
  dash: boolean
  // 점선 시작 위상 — 원래 획 시작부터 이 조각 시작까지의 경로 길이(이미지 짧은 변 대비 비율).
  // 지우개로 잘린 점선 조각만 갖는다(없으면 0). 조각마다 점선이 처음부터 다시 시작해 무늬가 밀리지 않게 한다.
  dashOffset?: number
}

// 그림을 모두 지우면 drawing 자체를 null로 둔다 (빈 strokes 저장 금지)
export interface PhotoDrawing {
  v: typeof PHOTO_DRAWING_VERSION
  strokes: PhotoStroke[]
}
